export default {
      id: "circle__link-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__link",
      toString: function () {
        return this.url;
      }
    }